import React, { useContext, useEffect, useState } from "react";
import PageTitle from "./PageTitle";
import { GlobalContext } from "../context/GlobalContext";

// Function to decode HTML entities
function htmlDecode(input) {
  var e = document.createElement("textarea");
  e.innerHTML = input;
  // handle case of empty input
  return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}

export default function ContactPage() {
  const { settings } = useContext(GlobalContext);
  const [hide, setHide] = React.useState(false);

  // Effect to set document title dynamically
  useEffect(() => {
    document.title = `Contact Us | ${settings.websitename}`;
  }, [settings]);

  // Effect to conditionally hide elements based on domain
  useEffect(() => {
    const journals = [
      "www.botanyjournals.com",
      "www.entomologyjournals.com",
      "www.fishjournals.com",
      "www.foodsciencejournal.com",
      "www.chemicaljournals.com",
      "www.chemistryjournal.in",
      "www.pharmacyjournal.net",
      "www.pharmacyjournal.in",
      "www.biologyjournal.in",
      "www.allsubjectjournal.com",
      "www.allstudiesjournal.com",
      "www.multistudiesjournal.com",
      "www.multieducationjournal.com",
      "www.socialsciencejournal.in",
      "www.sportsjournal.in",
      "www.managejournal.com",
      "www.allengineeringjournal.in",
      "www.medicalsciencejournal.com",
      "www.lawjournals.org",
      "www.englishjournals.com",
      "www.hindijournal.com",  
      "www.allinnovationjournal.com",
      "www.multiinnovationjournal.com",
      "www.humanitiesjournals.com",
      "www.socialsciencejournal.net",
      "www.sociologyjournal.in",
      "www.physicaleducationjournal.com",
      "www.commercejournal.in",
      "www.commercejournals.com",
      "www.managementjournal.in",
      "www.managementjournals.net",
      "www.biotechnologyjournals.com",
      "www.agriculturejournal.in",
      "www.ecologyjournal.in",
      "www.environmentaljournal.in",
      "www.radiologyjournal.in",
      "www.nursingjournal.in",
      "www.surgeryjournals.net",
      "www.surgeryjournal.in",
      "www.dentaljournal.net",
      "www.dentaljournal.in",
      "www.orthopaedicsjournal.in",
      "www.gynaecologyjournal.in",
      "www.journalofmedical.com",
      "www.lawjournals.net",
      "www.medicaljournals.in",  
      "www.hindijournal.in",
      "www.medicinesjournal.com",
      "www.allsciencejournal.com",
      "www.alleducationjournal.com",
      "www.thestudiesjournal.com",
      "www.biosciencejournals.com",
      "www.shodhjournal.com",
      "www.newresearchjournal.com",
    ];
    journals.includes(settings.domain) ? setHide(true) : setHide(false);
    console.log(hide," ",settings.domain);
  }, [settings]);


  return (
    <div>
      <div className="flex flex-col gap-5">
        <PageTitle title="CONTACT US" />
        {hide && <div>{settings.publication}</div>}
        <div
          dangerouslySetInnerHTML={{
            __html:
              typeof window !== "undefined" ? htmlDecode(settings.address) : "",
          }}
        ></div>
        WhatsApp your query
        <br />
        <div className="phoneno">
          <div>Ph:</div>
          <div id="phone">{settings.whatsup_number}</div>
          <img
            className="whatsapp-icon"
            src="/assets/images/whatsapp-icon.png"
            alt="WhatsApp Icon"
          />
        </div>
      </div>
    </div>
  );
}
